// @flow
import React from 'react';
import styles from './FacetGroupMenuTrigger.css';
import FacetGroupMenuTitle from './FacetGroupMenuTitle';
import CapacitorRipple from '../capacitor/Ripple';
import { injectIntl } from 'react-intl';
import type { IntlShape } from 'react-intl';

type OwnProps = {
  getTriggerText: Function,
  loadAndShowAllFacets: Function,
  type: string,
};

type Props = OwnProps & { intl: IntlShape };

const FacetGroupMenuTrigger = ({ getTriggerText, loadAndShowAllFacets, type, intl }: Props) => {
  const triggerText = getTriggerText(intl, type);
  return (
    <button
      className={styles.trigger}
      onClick={() => loadAndShowAllFacets(type)}
      aria-label={triggerText}
    >
      <CapacitorRipple />
      <FacetGroupMenuTitle triggerText={triggerText} />
    </button>
  );
};

export default injectIntl(FacetGroupMenuTrigger);
